<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row dense>
            <v-col cols="12" v-if="user.usertype === 'members' && memberinfo && (isapplying || iswaitingapproval || iswaitingpayment)">
               <panel-new-application v-if="isapplying"></panel-new-application>
               <panel-pending v-if="iswaitingapproval"></panel-pending>
               <panel-payment v-if="iswaitingpayment"></panel-payment>
            </v-col>
            <v-col cols="12" v-if="showHomeArticles">
               <v-row dense>
                  <v-col cols="12" sm="6" md="3" v-for="article in articles" :key="article.id">
                     <v-card class="home-article-card" outlined>
                        <v-img
                           v-if="articleImage(article)"
                           :src="articleImage(article)"
                           height="200"
                           contain
                        ></v-img>
                        <v-card-title class="subtitle-1 home-article-title">
                           {{ article.title }}
                        </v-card-title>
                        <v-card-text class="body-2 home-article-summary">
                           {{ articleSummary(article) }}
                        </v-card-text>
                        <v-card-actions>
                           <v-spacer></v-spacer>
                           <v-btn
                              v-if="articleDocument(article)"
                              color="primary"
                              small
                              dark
                              :href="articleDocument(article)"
                              target="_blank"
                           >
                              More
                           </v-btn>
                        </v-card-actions>
                     </v-card>
                  </v-col>
                  <v-col cols="12" v-if="!articlesLoading && articles.length === 0">
                     <v-alert type="info" outlined>
                        No home content available. Please add content from CMS @ Home.
                     </v-alert>
                  </v-col>
               </v-row>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import PanelNewApplication from './Panels/PanelNewApplication.vue'
import PanelPending from './Panels/PanelPending.vue'
import PanelPayment from './Panels/PanelPayment.vue'
// import PanelVoting from './Panels/PanelVoting.vue';

export default {
   name: "MOMDashboard",
   props: {
      user: Object
   },
   components: {
      DashboardLayout,
      BaseBreadcrumb,
      PanelNewApplication,
      PanelPending,
      PanelPayment,
      // PanelVoting,
   },

   data: () => ({
      page: {
         title: "Home",
      },
      breadcrumbs: [
         { text: "Dashboard", disabled: true },
      ],
      memberinfo: null,
      isapplying: false,
      iswaitingapproval: false,
      iswaitingpayment: false,
      isenabled: false,
      isdisabled: false,
      articles: [],
      articlesLoading: false,
   }),

   watch: {
      memberinfo: function (newval, oldval) {
         if (newval !== oldval) {
            if (newval.memberstatus === 0) { // Applying
               this.isapplying = true
               this.iswaitingapproval = false
               this.iswaitingpayment = false
               this.isenabled = false
               this.isdisabled = false
            }
            if (newval.memberstatus === 1) { // Pending Approval
               this.isapplying = false
               this.iswaitingapproval = true
               this.iswaitingpayment = false
               this.isenabled = false
               this.isdisabled = false
            }
            if (newval.memberstatus === 2) { // Pending Payment
               this.isapplying = false
               this.iswaitingapproval = false
               this.iswaitingpayment = true
               this.isenabled = false
               this.isdisabled = false
            }
            if (newval.memberstatus === 3) { // Active
               this.isapplying = false
               this.iswaitingapproval = false
               this.iswaitingpayment = false
               this.isenabled = true
               this.isdisabled = false
            }
            if (newval.memberstatus >= 4) { // Disabled
               this.isapplying = false
               this.iswaitingapproval = false
               this.iswaitingpayment = false
               this.isenabled = false
               this.isdisabled = true
            }
         }
      }
   },

   methods: {

      loadmemberinfo() {
         this.$nextTick( function () {
            if (this.user.usertype === 'members') {
               var url = '/member/info/' + this.user.id
               axios.get(url)
               .then((resp) => {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     // console.log(rtn.data)
                     this.memberinfo = rtn.data
                  } else {
                     this.isapplying = true
                     console.log(rtn.status + ': ' + rtn.error)
                     console.log('DATA: ' + rtn.data)
                  }
               })
            }
         })
      },

      loadArticles() {
         this.articlesLoading = true
         axios.get('/member/cms/list')
         .then((resp) => {
            var rtn = resp.data
            if (rtn.status === 'OK') {
               this.articles = rtn.data || []
            } else {
               this.articles = []
            }
         })
         .catch(() => {
            this.articles = []
         })
         .finally(() => {
            this.articlesLoading = false
         })
      },

      cleanAssetPath(path, file) {
         if (!path || !file) {
            return null
         }
         return '/' + String(path).replace(/^\/+|\/+$/g, '') + '/' + file
      },

      articleImage(article) {
         return this.cleanAssetPath(article.imagepath, article.image)
      },

      articleDocument(article) {
         return this.cleanAssetPath(article.documentpath, article.document)
      },

      plainText(value) {
         if (!value) {
            return ''
         }
         var holder = document.createElement('div')
         holder.innerHTML = value
         return holder.textContent || holder.innerText || ''
      },

      articleSummary(article) {
         return this.plainText(article.summary || article.content || '')
      },

   },

   computed: {
      showHomeArticles() {
         if (!this.user) {
            return false
         }
         if (this.user.usertype === 'sysadmins') {
            return true
         }
         if (this.user.usertype === 'members') {
            return this.memberinfo && !this.isapplying && !this.iswaitingapproval && !this.iswaitingpayment
         }
         return false
      },
   },

   mounted() {
      this.loadmemberinfo()
      this.loadArticles()
   }

};
</script>

<style>
.home-article-card {
   display: flex;
   flex-direction: column;
   height: 100%;
}

.home-article-title {
   align-items: flex-start;
   min-height: 56px;
   overflow-wrap: anywhere;
   word-break: normal;
}

.home-article-summary {
   flex: 1 1 auto;
   min-height: 70px;
   overflow-wrap: anywhere;
   white-space: pre-line;
}
</style>
